import Vconsole from 'vconsole'
let vConsole = null

if (['test', 'pre-production'].includes(process.env.REACT_APP_NODE_ENV || '')) {
  vConsole = new Vconsole()
}

export default vConsole